import React, { useEffect, useState } from "react";
import { renderTextField } from "../formcomponents";
import { reduxForm, Field, FieldArray } from "redux-form";
import FileListUpload from "./FileListUpload";
import { Grid, Divider, Label, Button } from "semantic-ui-react";
import axios from "axios";
import { BaseUrl } from "../formcomponents/Constants";

import Swal from "sweetalert2";
import MFileArrList from "./FieldArray/MFileArrList";
import MParArrList from "./FieldArray/MParArrList";
import MEmpArrList from "./FieldArray/MEmpArrList";

const validate = (values) => {
  const errors = {};
  if (!values.companyName) {
    errors.companyName = "Required";
  }
  if (!values.activities) {
    errors.activities = "Required";
  }
  if (!values.typeOfCompany) {
    errors.typeOfCompany = "Required";
  }

  const employeeArrList = [];
  // if (values.employeeList.length || values.employeeList) {
  //   values.employeeList.forEach((item, index) => {
  //     const itemErr = {};
  //     if (!item || !item.employeeName) {
  //       itemErr.employeeName = "Required";
  //       employeeArrList[index] = itemErr;
  //     }
  //   });
  //   if (employeeArrList.length) {
  //     errors.employeeList = employeeArrList;
  //   }
  // }

  return errors;
};

const NewCompanyForm = (props) => {
  const { handleSubmit, pristine, reset, submitting } = props;

  const sumbitForm = (values) => {
    // console.log("submitObject", `${JSON.stringify(values, null, 2)}`);
    axios
      .post(BaseUrl + "createCompany", values)
      .then((res) => {
        // console.log(res.data);
        if (res.data.errCode == 200) {
          Swal.fire("Company Details Updated");
        }
      })
      .catch((error) => {});
  };
  return (
    <div>
      <Grid columns={3}>
        <Grid.Row>
          <Grid.Column>
            <Field
              name="companyName"
              label="Name"
              type="text"
              component={renderTextField}
            />
          </Grid.Column>
          <Grid.Column>
            <Field
              name="activities"
              label="Activities"
              type="text"
              component={renderTextField}
            />
          </Grid.Column>
          <Grid.Column>
            <Field
              name="typeOfCompany"
              label="Type Of Company"
              type="text"
              component={renderTextField}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>{" "}
      <Divider section />
      <Label>
        <h3>Company Document List</h3>
      </Label>
      <FieldArray name="filesList" component={MFileArrList} />
      <Divider section />
      <Label>
        <h3>Partner Document List</h3>
      </Label>
      <FieldArray name="partnerList" component={MParArrList} />
      <Divider section />
      <Label>
        <h3>Employee Document List</h3>
      </Label>
      <FieldArray name="employeeList" component={MEmpArrList} />
      <br />
      <br />
      <Button
        type="submit"
        floated="right"
        positive
        disabled={submitting}
        onClick={handleSubmit((values) =>
          sumbitForm({
            ...values,
          })
        )}
      >
        Save
      </Button>
      <Button
        floated="right"
        negative
        disabled={pristine || submitting}
        onClick={reset}
      >
        Cancel
      </Button>
      <br />
      <br />
    </div>
  );
};

export default reduxForm({
  form: "NewCompanyForm",
  validate,
})(NewCompanyForm);
